import {
  VERIFY_PIN_REQUEST_SENT,
  VERIFY_PIN_REQUEST_SUCCEED,
  VERIFY_PIN_REQUEST_FAILED,
} from './constants';
import { RESET_GLOBAL_REDUCERS } from '../../../constants';

const initialState = {
  isLoading: false,
  shareOutcomesRequest: null,
};

const viewShareOutcomesRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_PIN_REQUEST_SENT:
      return {
        ...state,
        isLoading: true,
      };
    case VERIFY_PIN_REQUEST_SUCCEED:
      return {
        ...state,
        isLoading: false,
        shareOutcomesRequest: action.data.share_outcomes_request,
      };
    case VERIFY_PIN_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case RESET_GLOBAL_REDUCERS:
      return {
        ...state,
        isLoading: false,
        shareOutcomesRequest: null,
      };
    default:
      return state;
  }
};

export default viewShareOutcomesRequestReducer;
